import { render, staticRenderFns } from "./ModalPixels.vue?vue&type=template&id=9d12b3f4&"
import script from "./ModalPixels.vue?vue&type=script&lang=ts&"
export * from "./ModalPixels.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPixels.vue?vue&type=style&index=0&id=9d12b3f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports